import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Helmet } from "react-helmet";

export const DefaultSEO = ({ location }) => {
  const data = useStaticQuery(graphql`
    {
      prismicSeo {
        data {
          seo_title
          seo_description {
            text
          }
          seo_image {
            url
          }
        }
      }
    }
  `);

  return (
    <Helmet
      title={data.prismicSeo.data.seo_title}
      htmlAttributes={{ lang: "en" }}
      meta={[
        {
          name: "viewport",
          content:
            "width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1",
        },
        {
          name: "title",
          content: `${data.prismicSeo.data.seo_title}`,
        },
        {
          property: "og:title",
          content: `${data.prismicSeo.data.seo_title}`,
        },
        {
          name: "description",
          content: `${data.prismicSeo.data.seo_description.text}`,
        },
        {
          property: "og:image",
          content: `${
            data.prismicSeo.data.seo_image.url !== null
              ? data.prismicSeo.data.seo_image.url
              : ""
          }`,
        },
        {
          property: "og:image:secure_url",
          content: `${
            data.prismicSeo.data.seo_image.url !== null
              ? data.prismicSeo.data.seo_image.url
              : ""
          }`,
        },
        {
          property: "og:description",
          content: `${data.prismicSeo.data.seo_description.text}`,
        },
        {
          property: "og:image:width",
          content: `1200`,
        },
        {
          property: "og:image:height",
          content: `630`,
        },
        {
          property: "og:locale",
          content: `en`,
        },
        {
          property: "twitter:title",
          content: `${data.prismicSeo.data.seo_title}`,
        },
        {
          property: "twitter:description",
          content: `${data.prismicSeo.data.seo_description.text}`,
        },
        {
          property: "twitter:card",
          content: `summary_large_image`,
        },
        {
          property: "twitter:image",
          content: `${
            data.prismicSeo.data.seo_image.url !== null
              ? data.prismicSeo.data.seo_image.url
              : ""
          }`,
        },
        {
          property: "og:type",
          content: `website`,
        },
        {
          property: "og:url",
          content: location.href,
        },
        {
          property: "twitter:url",
          content: location.href,
        },
      ]}
      link={[
        {
          rel: "preload",
          href: "/fonts/fonts.css",
          as: "style",
        },
        {
          rel: "dns-prefetch",
          href: "https://images.prismic.io/three-rivers",
        },
        {
          rel: "preconnect",
          href: "https://images.prismic.io/three-rivers",
        },
        {
          rel: "preload",
          href: "/fonts/325dc276-c51e-4625-b8f8-a4cd50a12c1e.woff",
          as: "font",
          crossOrigin: "anonymous",
        },
        {
          rel: "preload",
          href: "/fonts/c6f622bb-e3f7-472a-a0f7-a7d93c0a6db0.woff2",
          as: "font",
          crossOrigin: "anonymous",
        },
      ]}
    >
      <link rel="canonical" href={location.href} />
    </Helmet>
  );
};
